import React, { Component } from "react";
import './styles.css';
import { Link } from 'react-router-dom'
import { Table, Button, Icon } from 'semantic-ui-react'
import Img from 'react-image'

import noPreviewImage from 'assets/images/box.svg'
import { productDetailPath } from 'routes'

class CompareChart extends Component {
  constructor(props) {
    super(props);

    this.hideProduct = this.hideProduct.bind(this);
    var handleHide = this.hideProduct;
    if (this.props.onHide) {
      handleHide = this.props.onHide
    }
    this.state = {
      productDataList: this.props.data,
      productListTodisplay: this.props.data,
      handleHideProduct: handleHide,
      hideItemOption: false
    };
  }

  render() {
    return (
      <div className="compare-table">
        {this.generateContent(this.state.productListTodisplay)}
      </div>
    );
  }

  generateContent(data) {
    if (data.length <= 0) {
      return "No products to display";
    }

    return (
      <Table definition singleLine>
        {this.generateHeader(data)}
        {this.generateBody(data)}
      </Table>
    )
  }

  generateHeader(data) {
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell />
          {data.map((product, i) => this.productHeaderDetails(product, i))}
        </Table.Row>
      </Table.Header>
    );
  }
  productHeaderDetails(product, i) {
    return (
      <Table.HeaderCell key={`header-cell-${i}`}>
        <Img
          style={{ opacity: product.image ? '' : '0.4'}}
          width='200' height='200'
          src={[product.image, noPreviewImage]}
        />
        <div style={{padding: '10px 0'}}>
          <Link to={productDetailPath(product.id)}>{product.name}</Link>
        </div>
        {(() => {
          if (this.props.hideItemOption) {
            return (
              <Button icon labelPosition='left' size='mini' onClick={() => { this.state.handleHideProduct(product.id); this.hideProduct(product.id)}}>
                <Icon name='trash' />
                Remove from wishlist
              </Button>
            )
          }
        })()}
      </Table.HeaderCell>
    )
  }

  generateBody(data) {
    return (
      <Table.Body>
        {this.props.features.map(feature => this.productComparisonFeature(feature, data))}
      </Table.Body>
    );
  }

  productComparisonFeature(feature, data) {
    if (data.find(item => item[feature] !== "N/A")) {
      return (
        <Table.Row>
          <Table.Cell>
            {feature}
          </Table.Cell>
          {data.map(product => this.getFeatureForProduct(product, feature))}
        </Table.Row>
      );
    }
  }
  getFeatureForProduct(product, feature) {
    return <Table.Cell>{product[feature]}</Table.Cell>;
  }

  hideProduct(product_id) {
    var temp_list = this.state.productListTodisplay;

    temp_list = temp_list.filter(item => item.id !== product_id);

    this.setState({
      productListTodisplay: temp_list
    })
  }

}

export default CompareChart;